/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import datApi from '../services/dat';
import CopyableText from '../components/CopyableText';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { checkDATConditions, convertHoursToHM } from '../utils';
import useMediaQuery from '../hook/useMediaQuery'
function SearchPage() {
  const params = new URLSearchParams(window.location.search);
  const [drivingClass, setDrivingClass] = useState(params.get('class') || '');
  const [name, setName] = useState(params.get('name') || '');
  const [loading, setLoading] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [result, setResult] = useState({});
  const isDesktop = useMediaQuery('(min-width: 768px)');

  useEffect(() => {
    const allChecked = rowData.every((row) => row.checked);
    setAllChecked(allChecked);
  }, [rowData]);

  const [colDefs] = useState([
    {
      headerName: 'STT',
      valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : ''),
      width: 80,
      pinned: 'left', // Cố định cột STT bên trái
    },
    {
      field: 'checked',
      headerName: 'Trạng thái',
      flex: 1,
      minWidth: 120,
      cellRenderer: (params) => {
        return params.data?.checked === true ? (
          <span className='text-success'>Đã kiểm tra</span>
        ) : params.data?.checked === false ? (
          <span className='text-danger'>Chưa kiểm tra</span>
        ) : (
          <span className='text-danger'>Chưa kiểm tra</span>
        );
      },
    },
    // {
    //   field: 'violation',
    //   headerName: 'Kết quả',
    //   flex: 1,
    //   minWidth: 90,
    //   valueFormatter: (params) => {
    //     return params.value ? 'Loại' : 'Nhận';
    //   },
    // },
    { field: 'session_id', headerName: 'Mã phiên' },
    { field: 'violation', headerName: 'Vi phạm', flex: 1, minWidth: 300 },
    {
      field: 'start_time',
      headerName: 'Thời gian bắt đầu',
      cellRenderer: (params) => {
        return new Date(params.value).toLocaleString('en-GB', {
          timeZone: 'Asia/Ho_Chi_Minh',
        });
      },
    },
    {
      field: 'end_time',
      headerName: 'Thời gian kết thúc',
      cellRenderer: (params) => {
        return new Date(params.value).toLocaleString('en-GB', {
          timeZone: 'Asia/Ho_Chi_Minh',
        });
      },
    },
    {
      field: 'duration',
      headerName: 'Thời lượng (giờ)',
      cellRenderer: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'distance',
      headerName: 'Quãng đường (km)',
      cellRenderer: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    { field: 'trainee_name', headerName: 'Tên học viên', cellRenderer: (p) => <CopyableText value={p.value} /> },
    { field: 'ten_khoa_hoc', headerName: 'Tên khoá học' },
    {
      field: 'auto_distance',
      headerName: 'Quãng đường TĐ',
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'auto_duration',
      headerName: 'Thời gian TĐ',
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'night_distance',
      headerName: 'Quãng đường đêm',
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'night_duration',
      headerName: 'Thời gian đêm',
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'night_duration',
      headerName: 'Thời gian đêm đúng hạng',
      cellRenderer: (params) => {
        let val = 0;

        if (
          params.data.ten_khoa_hoc?.includes('B1') ||
          params.data.ten_khoa_hoc?.includes('BTĐ')
        ) {
          val = ['B1', 'B.01', 'B11'].includes(params.data.vehicle_hang)
            ? params.data.night_duration
              ? params.data.night_duration
              : 0
            : 0;
        } else if (
          params.data.ten_khoa_hoc?.includes('B2') ||
          params.data.ten_khoa_hoc?.includes('BSS')
        ) {
          val = ['B2', 'B'].includes(params.data.vehicle_hang)
            ? params.data.night_duration
              ? params.data.night_duration
              : 0
            : 0;
        } else if (params.data.ten_khoa_hoc?.includes('C1')) {
          val = ['C1', 'C'].includes(params.data.vehicle_hang)
            ? params.data.night_duration
              ? params.data.night_duration
              : 0
            : 0;
        }
        return val;
      },
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'manual_night_duration',
      headerName: 'TG đêm thủ công',
      editable: true,
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'distance_dung_hang',
      headerName: 'Quãng đường đúng hạng',
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    {
      field: 'duration_dung_hang',
      headerName: 'Thời gian đúng hạng',
      valueFormatter: (params) =>
        params.value ? Math.floor(params.value * 100) / 100 : 0,
    },
    { field: 'success_ratio', headerName: 'Tỷ lệ nhận diện' },
    { field: 'trainee_ma_dk', headerName: 'Mã đăng ký học viên', cellRenderer: (p) => <CopyableText value={p.value} /> },
    { field: 'instructor_name', headerName: 'Tên giáo viên' },
    { field: 'vehicle_hang', headerName: 'Hạng xe' },
    { field: 'vehicle_plate', headerName: 'Biển số xe' },
    { field: 'source', headerName: 'Nguồn' },
  ]);

  const searchDatData = async (q) => {
    setLoading(true);
    try {
      const data = await datApi.search(q);
      setRowData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (!name) {
      alert('Vui lòng nhập tên cần tra cứu');
      return;
    }

    searchDatData({
      search: {
        ...(name && { name }),
        ...(drivingClass && { drivingClass }),
      },
      filter: {},
      skip: 0,
      limit: 50,
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = 'Tra cứu DAT';

    if (name) {
      searchDatData({
        search: {
          ...(name && { name }),
          ...(drivingClass && { drivingClass }),
        },
        filter: {},
        skip: 0,
        limit: 50,
      });
    }
  }, []);

  useEffect(() => {
    const totalDuration = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.duration : 0),
      0
    );
    const totalDistance = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.distance : 0),
      0
    );
    const totalDurationDungHang = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.duration_dung_hang : 0),
      0
    );

    const totalDistanceDungHang = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.distance_dung_hang : 0),
      0
    );

    const totalNightDurationDungHang = rowData.reduce(
      (acc, cur) => {
        let val = 0;
        if (
          cur.ten_khoa_hoc?.includes('B1') ||
          cur.ten_khoa_hoc?.includes('BTĐ')
        ) {
          val = ['B1', 'B.01', 'B11'].includes(cur.vehicle_hang)
            ? cur.night_duration
              ? cur.night_duration
              : cur.manual_night_duration
              ? cur.manual_night_duration
              : 0
            : 0;
        } else if (
          cur.ten_khoa_hoc?.includes('B2') ||
          cur.ten_khoa_hoc?.includes('BSS')
        ) {
          val = ['B2', 'B'].includes(cur.vehicle_hang)
            ? cur.night_duration
              ? cur.night_duration
              : cur.manual_night_duration
              ? cur.manual_night_duration
              : 0
            : 0;
        } else if (cur.ten_khoa_hoc?.includes('C1')) {
          val = ['C1', 'C'].includes(cur.vehicle_hang)
            ? cur.night_duration
              ? cur.night_duration
              : cur.manual_night_duration
              ? cur.manual_night_duration
              : 0
            : 0;
        }
        return acc + (!cur.violation?.length ? parseFloat(val) : 0);
      },
      0
    );

    const totalNightDistance = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.night_distance : 0),
      0
    );

    const totalAutoDuration = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.auto_duration : 0),
      0
    );

    const totalAutoDistance = rowData.reduce(
      (acc, cur) => acc + (!cur.violation?.length ? cur.auto_distance : 0),
      0
    );

    const manualNightDuration = rowData.reduce(
      (acc, cur) =>
        acc +
        (!cur.violation?.length && cur.manual_night_duration
          ? parseFloat(cur.manual_night_duration)
          : 0),
      0
    );

    const result = checkDATConditions(
      rowData[0]?.ten_khoa_hoc?.split('-')?.[0],
      totalDuration,
      totalDistance,
      totalDurationDungHang,
      totalNightDurationDungHang,
      totalAutoDuration
    );
    setResult({
      totalDuration,
      totalDistance,
      totalDurationDungHang,
      totalDistanceDungHang,
      totalNightDurationDungHang,
      totalNightDistance,
      totalAutoDuration,
      totalAutoDistance,
      manualNightDuration,
      ...result,
    });
  }, [rowData]);

  return (
    <Container
      style={{
        height: '100vh',
      }}
      fluid
    >
      <Row
        className='d-flex justify-content-between align-items-center'
        style={{ height: '12%' }}
      >
        <Col xs={8} md={4}>
          <Form.Control
            type='text'
            placeholder='Nhập tên cần tra cứu'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Col>
        <Col xs={4}>
          <Form.Control
            type='text'
            placeholder='Tên khoá học'
            value={drivingClass}
            onChange={(e) => setDrivingClass(e.target.value)}
          />
        </Col>
        <Col xs={12} md={4}>
          <Button
            onClick={handleSearch}
            variant='primary'
            disabled={loading}
            className='w-100'
          >
            Tra cứu
          </Button>
        </Col>
      </Row>
      <Row style={{ height: isDesktop ? '15%' : '35%' }}>
        <Col>
          Tổng TG:{' '}
          <span className='fw-bold'>
            {convertHoursToHM(result?.totalDuration)}
            <br />
            {result?.details?.totalTG === 'Đã đủ' ? (
              <span className='text-success'>{result?.details?.totalTG}</span>
            ) : (
              <span className='text-danger'>{result?.details?.totalTG}</span>
            )}
          </span>
        </Col>
        <Col>
          Tổng QĐ:{' '}
          <span className='fw-bold'>
            {Math.floor(result?.totalDistance * 100) / 100} km
            <br />
            {result?.details?.totalQD === 'Đã đủ' ? (
              <span className='text-success'>{result?.details?.totalQD}</span>
            ) : (
              <span className='text-danger'>{result?.details?.totalQD}</span>
            )}
          </span>
        </Col>
        <Col>
          TG đúng hạng:{' '}
          <span className='fw-bold'>
            {convertHoursToHM(result?.totalDurationDungHang)} <br />
            {result?.details?.TG_dung_hang === 'Đã đủ' ? (
              <span className='text-success'>
                {result?.details?.TG_dung_hang}
              </span>
            ) : (
              <span className='text-danger'>
                {result?.details?.TG_dung_hang}
              </span>
            )}
          </span>
        </Col>
        <Col>
          QĐ đúng hạng: {Math.floor(result?.totalDistanceDungHang * 100) / 100}{' '}
          km
        </Col>
        {/* <Col>
          TG ban đêm:{' '}
          <span className='fw-bold'>
            {convertHoursToHM(
              result?.totalNightDuration + result?.manualNightDuration
            )}
            <br />
            {result?.details?.TG_ban_dem === 'Đã đủ' ? (
              <span className='text-success'>
                {result?.details?.TG_ban_dem}
              </span>
            ) : (
              <span className='text-danger'>{result?.details?.TG_ban_dem}</span>
            )}
          </span>
        </Col> */}
        <Col>
          TG đêm đúng hạng:{' '}
          <span className='fw-bold'>
            {convertHoursToHM(
              result?.totalNightDurationDungHang
            )}
            <br />
            {result?.details?.TG_ban_dem_dung_hang === 'Đã đủ' ? (
              <span className='text-success'>
                {result?.details?.TG_ban_dem_dung_hang}
              </span>
            ) : (
              <span className='text-danger'>{result?.details?.TG_ban_dem_dung_hang}</span>
            )}
          </span>
          {result?.manualNightDuration ? (
            <div>
              (TG nhập tay:{' '}
              {convertHoursToHM(result?.manualNightDuration)})
            </div>
          ) : null}
        </Col>
        {/* <Col>
          QĐ ban đêm: {Math.floor(result?.totalNightDistance * 100) / 100} km
        </Col> */}
        <Col>
          TG tự động:{' '}
          <span className='fw-bold'>
            {convertHoursToHM(result?.totalAutoDuration)}
            <br />
            {result?.details?.TG_tu_dong === 'Đã đủ' ? (
              <span className='text-success'>
                {result?.details?.TG_tu_dong}
              </span>
            ) : (
              <span className='text-danger'>{result?.details?.TG_tu_dong}</span>
            )}
          </span>
        </Col>
        <Col>
          QĐ tự động: {Math.floor(result?.totalAutoDistance * 100) / 100} km
        </Col>
        <Col>
          Kết luận:{' '}
          {result?.valid && allChecked ? (
            <span className='text-success fw-bold'>Đã đủ DAT</span>
          ) : (
            <span className='text-danger fw-bold'>Chưa kiểm</span>
          )}
        </Col>
      </Row>
      {loading ? (
        <p className='text-center'>Đang tìm kiếm...</p>
      ) : (
        <Row
          className='ag-theme-quartz'
          style={{ height: isDesktop ? '73%' : '50%' }}
        >
          {rowData.length ? (
            <AgGridReact
              rowData={rowData}
              columnDefs={colDefs}
              gridOptions={{
                getRowStyle: (params) => {
                  if (params.data?.violation?.length) {
                    return { backgroundColor: '#FF6666' };
                  }
                  return null;
                },
              }}
            />
          ) : (
            <p className='text-center'>Không có dữ liệu</p>
          )}
        </Row>
      )}
    </Container>
  );
}

export default SearchPage;
